import { GridFields } from 'components';
import { getYesOrNoOptions, isYes } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';
import {
  Field,
  useFormContext,
} from 'modules/client/client/forms/w8BenFormForm';
import { DocumentsTableFeature } from 'modules/client/common/feature';

export interface FormContentProps {
  formType: 'W8BENForm' | 'W8BENEForm';
}

export const FormContent = ({ formType }: FormContentProps) => {
  const { values } = useFormContext();
  const { t } = useTranslation();

  return (
    <Stack spacing={24}>
      <GridFields>
        <Field.Autocomplete
          showRequiredMark
          label={t(`client.client.${formType}.field.label`)}
          name="W8BenForm.isUSSecuritiesInvestmentPlanned"
          optionLabelKey="label"
          options={getYesOrNoOptions(t)}
          optionValueKey="value"
          placeholder={t(`client.client.${formType}.field.placeholder`)}
          variant="select"
        />
      </GridFields>
      {isYes(values.W8BenForm.isUSSecuritiesInvestmentPlanned) && (
        <DocumentsTableFeature name="W8BenForm.files" />
      )}
    </Stack>
  );
};
